module.exports = __webpack_public_path__ + "static/img/m-spec-detail-checker.5e7db85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checker/m-spec-detail-checker.png
// module id = OZah
// module chunks = 1